import { Link } from "react-router-dom"

function Footer() {

    return(
        <footer>
            <Link to="/" className='atention'>Voltar ao Início</Link>
        </footer>
    )
}

export default Footer